<form novalidate (ngSubmit)="submit()" [formGroup]="form">
  <ion-list>
    <div class="cc-images">
      <div style="display: inline-block;"><img src="assets/imgs/checkout/visa.png"></div>
      <div style="display: inline-block;"><img src="assets/imgs/checkout/mc.png"></div>
      <div style="display: inline-block;"><img src="assets/imgs/checkout/amex.png"></div>
      <div style="display: inline-block;"><img src="assets/imgs/checkout/discover.png"></div>
    </div>

    <ion-item>
      <ion-label position="floating">
        {{ 'CreditCard.FullName' | translate }}
        @if (formErrors.has('fullName')) {
          <span color="danger"><br />{{formErrors.get('fullName')}}</span>
        }
      </ion-label>
      <ion-input autocomplete="new-password" formControlName="fullName" type="text" (ionChange)="submit()"></ion-input>
      @if (formFieldValidator('fullName', 'required')) {
        <span class="form-errors"
        >{{ 'CreditCard.FormErrors.CardHolderNameRequired' | translate}}</span>
      }
    </ion-item>

    <ion-item>
      <ion-label position="floating">
        {{ 'CreditCard.CardNumber' | translate }}
        @if (formErrors.has('number')) {
          <span color="danger"><br />{{formErrors.get('number')}}</span>
        }
      </ion-label>
      <!--<ion-input autocomplete="new-password" formControlName="number" type="number" (ionChange)="submit()"></ion-input>-->
      <ion-input autocomplete="new-password" formControlName="number" type="number" (ionChange)="submit()"></ion-input>

      @if (formFieldValidator('number', 'required')) {
        <span class="form-errors"
        >{{ 'CreditCard.FormErrors.CardNumberRequired' | translate}}</span>
      }
    </ion-item>

    <ion-grid class="no-padding">
      <ion-row>
        <ion-col class="no-padding" col-6>
          <ion-item class="item-has-value item-has-focus" style="height: 100%">
            <ion-label position="floating">
              {{ 'CreditCard.Expiration' | translate }}
              @if (formErrors.has('expiry')) {
                <span color="danger"><br />{{formErrors.get('expiry')}}</span>
              }
            </ion-label>
            <!--<ion-datetime displayFormat="MM/YYYY" pickerFormat="MMMM YYYY" [min]="minExpirationDate"
          [max]="maxExpirationDate" formControlName="expiry" (ionChange)="submit()"></ion-datetime>-->
          <!--<ion-input placeholder="MM/YYYY" formControlName="expiry" id="dateInput" (ionInput)="addSlashes(this)" maxlength="7"></ion-input>-->

          <div style="display:flex;">
            <ion-input autocomplete="new-password" item-start  placeholder="MM" (ionChange)="submitMonth()" formControlName="expiryMonth" type="number" style="width:50px; -webkit-appearance: none;"></ion-input>
            <p style="padding-right:20px;">/</p>
            <ion-input autocomplete="new-password" placeholder="YYYY" (ionChange)="submitYear()"  formControlName="expiryYear" type="number" style="width:75px;"></ion-input>
          </div>
          @if (formFieldValidator('expiryMonth', 'required')) {
            <span class="form-errors"
            >{{ 'CreditCard.FormErrors.ExpirationMonthRequired' | translate}}</span>
          }
          @if (formFieldValidator('expiryMonth', 'min') || formFieldValidator('expiryMonth', 'max')) {
            <span class="form-errors"
            >{{ 'CreditCard.FormErrors.ExpirationMonthInvalid' | translate}}</span>
          }
          @if (formFieldValidator('expiryYear', 'required')) {
            <span class="form-errors"
            >{{ 'CreditCard.FormErrors.ExpirationYearRequired' | translate}}</span>
          }
          @if (formFieldValidator('expiryYear', 'min') || formFieldValidator('expiryYear', 'max')) {
            <span class="form-errors"
            >{{ 'CreditCard.FormErrors.ExpirationYearInvalid' | translate}}</span>
          }
        </ion-item>
      </ion-col>

      <ion-col class="no-padding" col-6>
        <ion-item style="height: 100%">
          <ion-label position="floating">
            {{ 'CreditCard.Cvn' | translate }}
            @if (formErrors.has('cvc')) {
              <span color="danger"><br />{{formErrors.get('cvc')}}</span>
            }
          </ion-label>
          <div>
            <ion-input type="password" [pattern]="'[0-9]*'" formControlName="cvc" (ionChange)="submit()"></ion-input>
          </div>
          @if (formFieldValidator('cvc', 'required')) {
            <span class="form-errors">{{ 'CreditCard.FormErrors.CvcRequired' | translate}}</span>
          }
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-list>
</form>